<template>
  <section class="daily-hub" aria-labelledby="daily-hub-title">
    <div class="daily-hub__intro">
      <span class="daily-hub__eyebrow">กิจวัตรวันนี้</span>
      <h2 id="daily-hub-title">โตไปพร้อมกับคู่หูของคุณ</h2>
      <p>ให้อาหาร เล่นด้วยกัน และรับรางวัลจากภารกิจประจำวัน</p>
    </div>
    <div class="daily-hub__cards">
      <router-link class="daily-card daily-card--pet" to="/pet">
        <img :src="petImage" :alt="pet.name || 'คู่หูของฉัน'">
        <div>
          <small>คู่หูของฉัน</small>
          <strong>{{ pet.name || 'ตั้งชื่อคู่หู' }}</strong>
          <span>Lv. {{ pet.level || 1 }} · ร่าง {{ pet.stage || 1 }}</span>
        </div>
        <b aria-hidden="true">›</b>
      </router-link>
      <router-link class="daily-card" to="/checkin">
        <img :src="assets.checkin" alt="เช็กอินให้อาหาร">
        <div>
          <small>เช็กอินให้อาหาร</small>
          <strong>{{ checkinText }}</strong>
          <span>ฝากครบ 100 บาท รับ 10 XP</span>
        </div>
        <i v-if="checkin.canClaim" class="daily-card__dot" aria-label="พร้อมรับ"></i>
        <b aria-hidden="true">›</b>
      </router-link>
      <router-link class="daily-card" to="/missions">
        <img :src="assets.mission" alt="ภารกิจ">
        <div>
          <small>ภารกิจ</small>
          <strong>{{ missionText }}</strong>
          <span>ภารกิจรายวันและรายสัปดาห์</span>
        </div>
        <i v-if="missions.claimableCount" class="daily-card__badge">{{ missions.claimableCount }}</i>
        <b aria-hidden="true">›</b>
      </router-link>
    </div>
  </section>
</template>

<script>
import { qilinMenuAssets, qilinPetImage } from '../../config/qilinAssets'

export default {
  name: 'DailyLoopHub',
  props: {
    pet: { type: Object, required: true },
    checkin: { type: Object, required: true },
    missions: { type: Object, required: true }
  },
  data () { return { assets: qilinMenuAssets } },
  computed: {
    petImage () { return qilinPetImage(this.pet, false) },
    checkinText () {
      if (this.checkin.claimedToday) return 'ให้อาหารแล้ววันนี้ ✓'
      if (this.checkin.canClaim) return 'พร้อมให้อาหารแล้ว'
      return `ยอดฝาก ${Number(this.checkin.todayDeposit || 0).toLocaleString()} / 100 บาท`
    },
    missionText () {
      return this.missions.claimableCount
        ? `มี ${this.missions.claimableCount} รางวัลรอรับ`
        : 'ดูความคืบหน้าวันนี้'
    }
  }
}
</script>

<style scoped>
.daily-hub { width: min(1110px, calc(100% - 24px)); margin: 18px auto 22px; padding: 22px; border: 1px solid rgba(255, 218, 112, .25); border-radius: 24px; background: linear-gradient(145deg, rgba(43, 12, 64, .94), rgba(16, 5, 26, .96)); box-shadow: 0 20px 45px rgba(0, 0, 0, .26); color: #fff; font-family: 'Kanit', sans-serif; }
.daily-hub__eyebrow { color: #e2b8ff; font-size: 11px; font-weight: 900; letter-spacing: .1em; }
h2 { margin: 3px 0 2px; font-size: clamp(20px, 3vw, 28px); font-weight: 900; }
.daily-hub__intro p { margin: 0; color: rgba(255, 255, 255, .58); font-size: 13px; }
.daily-hub__cards { display: grid; grid-template-columns: 1.15fr 1fr 1fr; gap: 11px; margin-top: 17px; }
.daily-card { position: relative; display: flex; min-width: 0; min-height: 92px; align-items: center; gap: 11px; padding: 12px 38px 12px 12px; border: 1px solid rgba(255, 255, 255, .08); border-radius: 17px; background: rgba(255, 255, 255, .055); color: #fff; text-decoration: none; transition: transform .18s ease, border-color .18s ease; }
.daily-card:hover { transform: translateY(-2px); border-color: rgba(255, 218, 112, .38); color: #fff; text-decoration: none; }
.daily-card img { width: 68px; height: 68px; flex: 0 0 68px; object-fit: contain; filter: drop-shadow(0 8px 10px rgba(0, 0, 0, .28)); }
.daily-card:not(.daily-card--pet) img { width: 58px; height: 58px; flex-basis: 58px; }
.daily-card small, .daily-card strong, .daily-card span { display: block; }
.daily-card small { color: #c47cf0; font-size: 10px; font-weight: 800; }
.daily-card strong { overflow: hidden; margin: 2px 0; font-size: 14px; font-weight: 900; text-overflow: ellipsis; white-space: nowrap; }
.daily-card span { color: rgba(255, 255, 255, .55); font-size: 10px; }
.daily-card b { position: absolute; top: 50%; right: 14px; transform: translateY(-50%); color: rgba(255, 255, 255, .38); font-size: 27px; font-weight: 400; }
.daily-card__dot { position: absolute; top: 10px; right: 10px; width: 9px; height: 9px; border-radius: 50%; background: #ffd154; box-shadow: 0 0 0 5px rgba(255, 209, 84, .14); }
.daily-card__badge { position: absolute; top: 8px; right: 9px; display: grid; min-width: 22px; height: 22px; place-items: center; border-radius: 99px; background: #ef7c62; color: #fff; font-size: 11px; font-style: normal; }
@media (max-width: 840px) { .daily-hub__cards { grid-template-columns: 1fr; } }
@media (max-width: 575px) { .daily-hub { padding: 17px 13px; border-radius: 20px; } .daily-card { min-height: 82px; } .daily-card img { width: 58px; height: 58px; flex-basis: 58px; } }
</style>
